/* ShowHomeBarAppendage.js */

"use strict";
const _ = require("lodash");

class ShowHomeBarAppendage {
    constructor(can) {
        this._can = can;
    }
    startUp(fullRouteInfo) {
        let routeDestSection = _.get(fullRouteInfo, "newRouteDetails.s", false);
        if (
            routeDestSection === "LoginCenter" ||
            routeDestSection === "LogoutCenter" ||
            routeDestSection === "Eula" ||
            routeDestSection === "PasswordReset" ||
            routeDestSection === "Banner"
        ) {
            this._can.hideHomebar();
        } else {
            this._can.showHomebar();
        }
        return true;
    }
}

module.exports = ShowHomeBarAppendage;
module.exports.$inject = ["$teve.controlAppNav"];
